/**
 * Analytics Configuration
 *
 * Follow the setup guide in ANALYTICS_SETUP.md to get your GA4 Measurement ID.
 */

// GA4 Measurement ID - can be set via REACT_APP_GA4_MEASUREMENT_ID environment variable
// Format: G-XXXXXXXXXX
// See ANALYTICS_SETUP.md for instructions on how to get this ID
export const GA4_MEASUREMENT_ID =
  process.env.REACT_APP_GA4_MEASUREMENT_ID || 'G-MSB6KRVBP1';

// Analytics configuration options
export const analyticsConfig = {
  // Enable debug mode in development
  debug: process.env.NODE_ENV === 'development',

  // Disable analytics in development if needed
  enabled:
    process.env.NODE_ENV === 'production' ||
    process.env.REACT_APP_ANALYTICS_DEV === 'true',

  // Custom configuration
  gaOptions: {
    // Cookie settings
    cookieFlags: 'SameSite=None;Secure',

    // Anonymize IP addresses for privacy
    anonymize_ip: true,
  },
};

// Check if analytics is properly configured
export const isAnalyticsConfigured = (): boolean => {
  return (
    typeof GA4_MEASUREMENT_ID === 'string' &&
    GA4_MEASUREMENT_ID.startsWith('G-')
  );
};
